import {createApp} from 'vue';
import {
	Quasar, Dialog, QTable, Notify
} from 'quasar';
// import 'quasar-framework/dist/quasar.ie.polyfills';
import '@quasar/extras/material-icons/index.mjs';
import '@quasar/extras/fontawesome-v5/index.mjs';
import app from './app.vue';
import router from './router';

// globalThis.__VUE_OPTIONS_API__=true;
// globalThis.__VUE_PROD_DEVTOOLS__=true;
// Importing styl file allowed only for development purposes
// import './style/themes/main.css';
import './style/default.styl';

// if (process.env.NODE_ENV === 'development') {
// 	defaultStyle.use();
// }
const Vue = createApp(app).use(router);
Vue.use(Quasar, { plugins: { Dialog, Notify }, components: { QTable }});

// Vue.config.productionTip = false;

/* eslint-disable no-new */
Vue.component('gdpr-component', app);
Vue.mount('#app');
// Vue({
// 	el: '#app',
// 	router,
// 	template: '<app/>',
// 	components: { app }
// });
